import React from 'react'

function Information() {
  return (
    <div className="w-screen h-[80vh]  flex justify-center">
      <div className='my-auto'>
        <img
          className='w-16 mx-auto'
          src="https://cdn1.iconfinder.com/data/icons/database-41/100/database_data_storage_archive-14-512.png"
          alt="noInfo"
        />
        
          <p className='font-bodyFont mt-2'>No information availale!</p>
        
      </div>
    </div>
  );
}

export default Information